module.exports = __webpack_public_path__ + "img/7.4fcfca2d.png";